export class HttpForbiddenException extends Error {
  status: number;

  code: string;

  constructor(message: string) {
    super(message);
    this.name = 'HttpForbiddenException';
    this.status = 403;
    this.code = 'FORBIDDEN';
  }
}
